<div class="container">
  <div class="object-container">
    <app-section-header title="{{ 'workOrderObjectHierarchy.workLines' | translate }}"></app-section-header>

    <div class="table-header">
      @if (workOrder) {
        <div>
          <div class="work-order-number">{{ workOrder.workOrderNumber }}</div>
        </div>
      }
      <div class="select-all-objects-placeholder">
        <mat-checkbox
          class="mat-checkbox-xl"
          labelPosition="before"
          [formControl]="selectAllObjects"
          (change)="toggleAllObjects()"
          >{{ 'workOrderObject.selectAll' | translate }}</mat-checkbox
        >
      </div>
    </div>
    <div class="object-header">
      <div class="object-number">
        {{ 'workOrderObject.objectNumber' | translate }}
      </div>
      <div class="object-progress">
        {{ 'workOrderObject.progress' | translate }}
      </div>
      <div class="object-select">
        {{ 'workOrderObject.select' | translate }}
      </div>
      <div class="object-expand"></div>
    </div>

    @if (objects?.length === 0) {
      <app-empty-list info="{{ 'workOrderObjectHierarchy.empty.info' | translate }}"></app-empty-list>
    }
    @for (object of objects; track object) {
      <div class="object-list">
        <div class="object-list-item">
          <app-object
            [workOrder]="workOrder"
            [object]="object"
            [showProgress]="true"
            [level]="0"
            [statusCodes]="statusCodes"
            [objectList]="objects"
          >
          </app-object>
          <div class="object-list-footer"></div>
        </div>
      </div>
    }
  </div>

  @if (hasSelectedItems) {
    <app-report-progress-footer (destroyingElement)="clearSelection()"></app-report-progress-footer>
  }
</div>
